<template>
  <div class="columns is-multiline">

    <Sub title="Torre evaporativa" tag="TE" v-model:elements="implant.other_towers" v-slot="slotProps" :codes="implant.codes">
      <Tower :element="slotProps.element" />
    </Sub>

    <Sub title="Raffreddatore di liquido" tag="RV" v-model:elements="implant.other_coolers" v-slot="slotProps" :codes="implant.codes">
      <Cooler :element="slotProps.element" />
    </Sub>

    <Sub title="Scambiatore di calore intermedio" tag="SC" v-model:elements="implant.other_exchangers" v-slot="slotProps" :codes="implant.codes">
      <Exchanger :element="slotProps.element" />
    </Sub>

    <Sub title="Circuito interrato a condensazione / espansione diretta" tag="CI" v-model:elements="implant.other_circuits" v-slot="slotProps" :codes="implant.codes">
      <Circuit :element="slotProps.element" />
    </Sub>

    <Sub title="Unità di trattamento aria" tag="UT" v-model:elements="implant.other_units" v-slot="slotProps" :codes="implant.codes">
      <Unit :element="slotProps.element" />
    </Sub>

    <Sub title="Recuperatore di calore" tag="RC" v-model:elements="implant.other_recoverers" v-slot="slotProps" :codes="implant.codes">
      <Recoverer :element="slotProps.element" />
    </Sub>

  </div>
</template>
  
<script>
import Tower from './_9-other/tower'
import Cooler from './_9-other/cooler'
import Exchanger from './_9-other/exchanger'
import Circuit from './_9-other/circuit'
import Unit from './_9-other/unit'
import Recoverer from './_9-other/recoverer'

export default {
  components: {
    Tower,
    Cooler,
    Exchanger,
    Circuit,
    Unit,
    Recoverer
  },

  props: {
    implant: Object
  },
  emits: ['update:implant']
}
</script>